import React, { useState } from 'react';
import { DayPicker } from 'react-day-picker';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import 'react-day-picker/dist/style.css';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

const ModalContent = styled.div`
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  max-width: 500px;
  width: calc(100% - 40px);
  position: relative;
  margin: 20px;
  max-height: 90vh;
  overflow-y: auto;
  z-index: 10000;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
`;

const StepContainer = styled.div`
  margin-bottom: 20px;
`;

const Button = styled.button`
  background-color: #316C6E;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  margin: 10px auto;
  display: block;
  opacity: ${props => props.disabled ? 0.6 : 1};
  transition: opacity 0.3s ease;

  &:hover {
    opacity: ${props => props.disabled ? 0.6 : 0.9};
  }
`;


const CalendarContainer = styled.div`
  display: flex;
  justify-content: center;
  .rdp {
    margin: 0;
  }
`;

const TripCreationModal = ({ onClose, onCreateTrip, initialPOI }) => {
  const [dateRange, setDateRange] = useState({ from: undefined, to: undefined });
  const today = new Date();

  const handleDateRangeSelect = (range) => {
    setDateRange(range || { from: undefined, to: undefined });
  };

  const handleCreate = () => {
    if (dateRange?.from && dateRange?.to) {
      onCreateTrip({
        startDate: dateRange.from,
        endDate: dateRange.to,
        numPeople: 1,
        initialPOI
      });
    }
  };

  const isDateRangeSelected = dateRange?.from && dateRange?.to;

  return (
    <ModalOverlay>
      <ModalContent>
        <CloseButton onClick={onClose}>
          <FontAwesomeIcon icon={faTimes} />
        </CloseButton>
        <StepContainer>
          <h2>Select your trip dates</h2>
          <CalendarContainer>
            <DayPicker
              mode="range"
              selected={dateRange}
              onSelect={handleDateRangeSelect}
              numberOfMonths={1}
              disabled={{ before: today }}
            />
          </CalendarContainer>
        </StepContainer>
        <Button 
          onClick={handleCreate} 
          disabled={!isDateRangeSelected}
        >
          Create Trip
        </Button>
      </ModalContent>
    </ModalOverlay>
  );
};

export default TripCreationModal;
